import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../utils/axios";
import { API_ROUTES } from "./routes";
import { showToast } from "components/ui/toast";

export const useGetOpenHomeMusicQuery = () => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: [API_ROUTES.GET_OPEN_HOME_MUSIC],
    queryFn: () => api.get(API_ROUTES.GET_OPEN_HOME_MUSIC),
  });
  return { data: data?.data?.data ?? [], isPending, isError, error };
};

export const useGetOpenHomeMusicByIdQuery = (id) => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: [API_ROUTES.GET_OPEN_HOME_MUSIC, { id }],
    queryFn: () => api.get(`${API_ROUTES.GET_OPEN_HOME_MUSIC}/${id}`),
    enabled: !!id,
  });
  return { data: data?.data?.data ?? null, isPending, isError, error };
};

export const useCreateOpenHomeMusicMutation = () => {
  const queryClient = useQueryClient();
  const { mutate, isPending, isError, error, isSuccess } = useMutation({
    mutationFn: (formData) =>
      api.post(API_ROUTES.GET_OPEN_HOME_MUSIC, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      }),
    onSuccess: () => {
      showToast("success", "Track uploaded successfully");
      queryClient.invalidateQueries([API_ROUTES.GET_OPEN_HOME_MUSIC]);
    },
    onError: (err) => {
      showToast(
        "error",
        err?.response?.data?.message || "Failed to upload track"
      );
    },
  });
  return { mutate, isPending, isError, error, isSuccess };
};

export const useUpdateOpenHomeMusicMutation = () => {
  const queryClient = useQueryClient();
  const { mutate, isPending, isError, error, isSuccess } = useMutation({
    mutationFn: ({ id, data }) =>
      api.put(`${API_ROUTES.GET_OPEN_HOME_MUSIC}/${id}`, data),
    onSuccess: () => {
      showToast("success", "Track updated successfully");
      queryClient.invalidateQueries([API_ROUTES.GET_OPEN_HOME_MUSIC]);
    },
    onError: (err) => {
      showToast(
        "error",
        err?.response?.data?.message || "Failed to update track"
      );
    },
  });
  return { mutate, isPending, isError, error, isSuccess };
};

export const useDeleteOpenHomeMusicMutation = () => {
  const queryClient = useQueryClient();
  const { mutate, isPending, isError, error, isSuccess } = useMutation({
    mutationFn: (id) =>
      api.delete(`${API_ROUTES.GET_OPEN_HOME_MUSIC}/${id}`),
    onSuccess: () => {
      showToast("success", "Track deleted successfully");
      queryClient.invalidateQueries([API_ROUTES.GET_OPEN_HOME_MUSIC]);
    },
    onError: (err) => {
      showToast(
        "error",
        err?.response?.data?.message || "Failed to delete track"
      );
    },
  });
  return { mutate, isPending, isError, error, isSuccess };
};
